interface FilterChipProps {
  label: string;
  active?: boolean;
  onClick: () => void;
}

export default function FilterChip({ label, active = false, onClick }: FilterChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap cursor-pointer border transition-colors ${
        active
          ? 'bg-primary-500 border-primary-500 text-foreground-950'
          : 'bg-background-100 border-background-200 text-foreground-600 hover:text-foreground-950 hover:border-background-300'
      }`}
    >
      {label}
    </button>
  );
}